/* eslint-disable jsx-a11y/anchor-is-valid */
import { globalVariables } from "helper/globalVariables";
import { externalLinkWhite } from "helper/icons";
import { Button } from "shared/Components/button";

export const TrialResultCard = ({
  id,
  name,
  date,
  location,
  level,
  status,
  onDetail,
}) => {
  // Fix status text: "Close" -> "Closed"
  const displayStatus = status === "Close" ? "Closed" : status;

  return (
    <div class="bg-white w-80">
      <div class="flex justify-start flex-col border-b pb-3">
        <h2 class="text-lg font-semibold text-gray-900">
          {globalVariables.uploadTrialResults}
        </h2>
        <h2 class="text-sm text-gray-600">{date}</h2>
      </div>
      <div class="flex justify-start flex-col mt-4">
        <h2 class="text-xs text-gray-600">Name</h2>
        <h2 class="text-md">{name}</h2>
      </div>
      <div class="flex justify-start flex-col mt-4">
        <h2 class="text-xs text-gray-600">Location</h2>
        <h2 class="text-md">{location}</h2>
      </div>
      <div class="flex justify-start flex-col mt-4">
        <h2 class="text-xs text-gray-600">Level</h2>
        <h2 class="text-md">{level}</h2>
      </div>
      <div class="flex justify-start flex-col mt-4">
        <h2 class="text-xs text-gray-600">Status</h2>
        <h2 class="text-md">{displayStatus}</h2>
      </div>
      <div class="flex justify-start flex-col mt-4">
        <h2 class="text-xs text-gray-600">Close Date</h2>
        <h2 class="text-md">{date}</h2>
      </div>
      <div className="mt-5 pt-5 border-t">
        <Button
          label="View Results"
          width="w-[100%] max-[380px]:w-[90%]"
          onClick={() => onDetail(id)}
          icon={externalLinkWhite}
          prefix={false}
        />
      </div>
    </div>
  );
};
